import React from "react";
import { Page, Document, StyleSheet } from "@react-pdf/renderer";
import InvoiceTitle from "./InvoiceTitle";
import InvoiceNo from "./InvoiceNo";
import BillTo from "./BillTo";
import InvoiceThankYouMsg from "./InvoiceThankYouMsg";
import InvoiceItemsTable from "./InvoiceItemsTable";
import ShipTo from "./ShipTo";
import { Image } from "@mui/icons-material";

const styles = StyleSheet.create({
    page: {
        backgroundColor: '#fff',
        fontFamily: 'Helvetica',
        fontSize: 11,
        paddingTop: 30,
        paddingLeft: 50,
        paddingRight: 50,
        lineHeight: 1.5,
        flexDirection: 'column',
    },
    logo: {
        width: 84,
        height: 70,
        marginLeft: 'auto',
        marginRight: 'auto'
    }
});

const PdfDocument = ({ invoicedata }) => {
    // console.log("invoicedata",invoicedata)
    // const did = invoicedata.discountType
    // const cusid = (did === "BASIC" ) ? 1/10 : 1/5;
    // const fdfd = `https://storage.googleapis.com/mperito-dev-bucket/uploads/catalog/product/images/baseImageUrl_1674471516048airfryer.jpg}`
    return (
        <Document>
            <Page size="A4" style={styles.page} >
            {/* <Image style={styles.logo} src={fdfd} /> */}
                <InvoiceTitle title={'Invoice  Details'} />
                <br/><br/>
                <InvoiceNo invoice={invoicedata} />
                <BillTo invoice={invoicedata} />
                <ShipTo invoice={invoicedata} />
                <InvoiceItemsTable invoice={invoicedata} />
                <InvoiceThankYouMsg />
            </Page>
        </Document>
    );
}

export default PdfDocument;